import { ButtonGroup, IconButton, LuIcon, Text, radiusCva, useProvider } from "@overmap-ai/blocks"
import { UNTITLED_DOCUMENT_TITLE } from "@overmap-ai/common"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { navigationLink } from "../../../cva"
import { modelIconMapping } from "../../../mappings/icons"
import { DocumentIcon } from "../../Icons/DocumentIcon"
import { TreeExpandedButton } from "../components"
import type { ExtendableTreeProps } from "../typings"
import type { DocumentNode } from "./hooks"

interface DocumentTreeProps extends ExtendableTreeProps<DocumentNode> {
	onAddDocument: (parentDocument: DocumentNode) => void
	onClickDocument: (document: DocumentNode) => void
}

export const DocumentTree = memo<DocumentTreeProps>((props) => {
	const { tree, onAddDocument, onClickDocument } = props
	const { radius } = useProvider()

	return (
		<ol {...tree.getContainerProps()} className="flex w-full flex-col gap-0.5">
			{tree.getItems().map((item) => (
				<li
					className={cx(navigationLink(), radiusCva({ radius, maxLarge: false }))}
					{...item.getProps()}
					key={item.getId()}
				>
					<span
						onClick={() => onClickDocument(item.getItemData())}
						className="flex min-w-0 grow items-center gap-2"
						style={{
							paddingLeft: `${item.getItemMeta().level * 24}px`,
						}}
					>
						<DocumentIcon documentId={item.getId()} inline />
						<Text className="truncate">{item.getItemData().title || UNTITLED_DOCUMENT_TITLE}</Text>
					</span>
					<ButtonGroup size="xs" variant="ghost" accentColor="base">
						{item.isFolder() && <TreeExpandedButton item={{ ...item }} />}
						<IconButton onClick={() => onAddDocument(item.getItemData())}>
							<LuIcon icon={modelIconMapping.add} />
						</IconButton>
					</ButtonGroup>
				</li>
			))}
		</ol>
	)
})
DocumentTree.displayName = "DocumentTree"
